/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Portalsignin_Link_Sent_BodyInputs */

const en_portalsignin_link_sent_body = /** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a sign-in link to ${i?.email}. It works once and expires in a few minutes.`)
};

/** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */
const ar_portalsignin_link_sent_body = en_portalsignin_link_sent_body;

/** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */
const he_portalsignin_link_sent_body = en_portalsignin_link_sent_body;

/** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */
const ur_portalsignin_link_sent_body = en_portalsignin_link_sent_body;

/** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */
const es_portalsignin_link_sent_body = en_portalsignin_link_sent_body;

/** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */
const fr_portalsignin_link_sent_body = en_portalsignin_link_sent_body;

/** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */
const de_portalsignin_link_sent_body = en_portalsignin_link_sent_body;

/** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */
const pt_portalsignin_link_sent_body = en_portalsignin_link_sent_body;

/** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */
const hi_portalsignin_link_sent_body = en_portalsignin_link_sent_body;

/** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */
const bn_portalsignin_link_sent_body = en_portalsignin_link_sent_body;

/**
* | output |
* | --- |
* | "We sent a sign-in link to {email}. It works once and expires in a few minutes." |
*
* @param {Portalsignin_Link_Sent_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_link_sent_body = /** @type {((inputs: Portalsignin_Link_Sent_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Link_Sent_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_link_sent_body(inputs)
	if (locale === "he") return he_portalsignin_link_sent_body(inputs)
	if (locale === "ur") return ur_portalsignin_link_sent_body(inputs)
	if (locale === "es") return es_portalsignin_link_sent_body(inputs)
	if (locale === "fr") return fr_portalsignin_link_sent_body(inputs)
	if (locale === "de") return de_portalsignin_link_sent_body(inputs)
	if (locale === "pt") return pt_portalsignin_link_sent_body(inputs)
	if (locale === "hi") return hi_portalsignin_link_sent_body(inputs)
	if (locale === "bn") return bn_portalsignin_link_sent_body(inputs)
	return en_portalsignin_link_sent_body(inputs)
});